import React, { useEffect, useState, useMemo } from 'react';
import api from '../utils/api';

const S = {
  input:    { padding: '7px 10px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13, width: '100%', boxSizing: 'border-box' },
  btnBlue:  { padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' },
  btnGreen: { padding: '6px 14px', background: '#1A7A3C', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  btnGhost: { padding: '5px 11px', background: 'none', border: '1px solid #DDD', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#555' },
  btnRed:   { padding: '5px 11px', background: 'none', border: '1px solid #E05040', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#C0392B' },
  label:    { fontSize: 11, color: '#666', display: 'block', marginBottom: 3 },
};

const leegForm = () => ({
  artikelnummer: '', naam: '', productfiche_id: '', diameter_mm: '', tanden_per_stuk: '',
  standaard_materiaal: '', standaard_leverancier_id: '', opmerkingen: '',
});

function RouteEditor({ route, setRoute, operaties }) {
  const voegToe = () => {
    if (!operaties.length) return;
    setRoute(r => [...r, { operatie_id: operaties[0].id, volgorde: r.length + 1, label: '', is_extern: false, externe_partij: '' }]);
  };
  const wijzig = (i, veld, val) => setRoute(r => r.map((s, j) => j === i ? { ...s, [veld]: val } : s));
  const verwijder = (i) => setRoute(r => r.filter((_, j) => j !== i));
  const verplaats = (i, d) => {
    const ni = i + d;
    if (ni < 0 || ni >= route.length) return;
    setRoute(r => { const n = [...r]; [n[i], n[ni]] = [n[ni], n[i]]; return n; });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: '#333' }}>Route ({route.length} stappen)</span>
        <button type="button" onClick={voegToe} style={S.btnBlue}>+ Stap</button>
      </div>
      {route.length === 0 && (
        <div style={{ fontSize: 12, color: '#AAA', fontStyle: 'italic', padding: '8px 0' }}>
          Nog geen stappen — klik op + Stap of laad van productfiche
        </div>
      )}
      {route.map((stap, i) => (
        <div key={i} style={{ background: '#F7F9FC', border: '1px solid #E8E8E8', borderRadius: 7, padding: '8px 10px', marginBottom: 6 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 11, color: '#AAA', minWidth: 18, textAlign: 'right' }}>{i + 1}</span>
            <select value={stap.operatie_id}
              onChange={e => wijzig(i, 'operatie_id', parseInt(e.target.value))}
              style={{ flex: 1, padding: '5px 8px', border: '1px solid #DDD', borderRadius: 6, fontSize: 12 }}>
              {operaties.map(o => <option key={o.id} value={o.id}>{o.nummer}. {o.naam}</option>)}
            </select>
            <input placeholder="Label (opt.)" value={stap.label || ''}
              onChange={e => wijzig(i, 'label', e.target.value)}
              style={{ width: 130, padding: '5px 8px', border: '1px solid #DDD', borderRadius: 6, fontSize: 12 }} />
            <label style={{ fontSize: 12, display: 'flex', gap: 4, alignItems: 'center', whiteSpace: 'nowrap', cursor: 'pointer', color: '#555' }}>
              <input type="checkbox" checked={!!stap.is_extern} onChange={e => wijzig(i, 'is_extern', e.target.checked)} />
              Extern
            </label>
            <div style={{ display: 'flex', gap: 2 }}>
              <button type="button" onClick={() => verplaats(i, -1)} disabled={i === 0}
                style={{ ...S.btnGhost, padding: '2px 6px', color: i === 0 ? '#CCC' : '#555' }}>↑</button>
              <button type="button" onClick={() => verplaats(i, 1)} disabled={i === route.length - 1}
                style={{ ...S.btnGhost, padding: '2px 6px', color: i === route.length - 1 ? '#CCC' : '#555' }}>↓</button>
            </div>
            <button type="button" onClick={() => verwijder(i)}
              style={{ background: 'none', border: 'none', color: '#C0392B', cursor: 'pointer', fontSize: 20, lineHeight: 1, padding: '0 2px' }}>×</button>
          </div>
          {stap.is_extern && (
            <div style={{ marginLeft: 26, marginTop: 5 }}>
              <input placeholder="Externe partij..." value={stap.externe_partij || ''}
                onChange={e => wijzig(i, 'externe_partij', e.target.value)}
                style={{ width: '100%', padding: '4px 8px', border: '1px solid #F0C060', borderRadius: 6, fontSize: 12, background: '#FFFBF0', boxSizing: 'border-box' }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default function ArtikelenPage({ user }) {
  const isPlanner = ['planner', 'admin'].includes(user?.rol);

  const [artikelen, setArtikelen] = useState([]);
  const [fiches, setFiches]       = useState([]);
  const [families, setFamilies]   = useState([]);
  const [operaties, setOperaties] = useState([]);
  const [leveranciers, setLeveranciers] = useState([]);

  const [zoek, setZoek]           = useState('');
  const [familieFilter, setFamilieFilter] = useState('');
  const [toonInactief, setToonInactief]   = useState(false);

  const [bewerk, setBewerk]       = useState(null); // { ...artikel, route: [] }
  const [bewerkRoute, setBewerkRoute] = useState([]);
  const [nieuw, setNieuw]         = useState(null); // null of { form, route }
  const [nieuwForm, setNieuwForm] = useState(leegForm());
  const [nieuwRoute, setNieuwRoute] = useState([]);

  const [bezig, setBezig]         = useState(false);
  const [fout, setFout]           = useState('');

  const laad = () => api.get('/artikelen').then(r => setArtikelen(r.data));

  useEffect(() => {
    Promise.all([
      api.get('/artikelen'),
      api.get('/productfiches'),
      api.get('/productfamilies'),
      api.get('/operaties'),
      api.get('/leveranciers'),
    ]).then(([a, f, fam, o, l]) => {
      setArtikelen(a.data);
      setFiches(f.data);
      setFamilies(fam.data.filter(x => x.actief !== false));
      setOperaties(o.data.filter(x => x.actief !== false));
      setLeveranciers(l.data);
    });
  }, []);

  // Laad route van productfiche
  const laadFicheRoute = async (ficheId, setRoute) => {
    if (!ficheId) { setRoute([]); return; }
    try {
      const { data } = await api.get(`/productfiches/${ficheId}`);
      setRoute((data.route || []).map(s => ({
        operatie_id: s.operatie_id, volgorde: s.volgorde,
        label: s.label || '', is_extern: s.is_extern || false, externe_partij: s.externe_partij || '',
      })));
    } catch { setRoute([]); }
  };

  const openBewerk = async (artikel) => {
    const { data } = await api.get(`/artikelen/${artikel.id}`);
    setBewerk({ ...data });
    setBewerkRoute((data.route || []).map(s => ({
      operatie_id: s.operatie_id, volgorde: s.volgorde,
      label: s.label || '', is_extern: s.is_extern || false, externe_partij: s.externe_partij || '',
    })));
    setFout('');
  };

  const slaOp = async () => {
    setBezig(true); setFout('');
    try {
      await api.put(`/artikelen/${bewerk.id}`, {
        ...bewerk,
        diameter_mm: bewerk.diameter_mm || null,
        tanden_per_stuk: bewerk.tanden_per_stuk ? parseInt(bewerk.tanden_per_stuk) : null,
        productfiche_id: bewerk.productfiche_id || null,
        standaard_leverancier_id: bewerk.standaard_leverancier_id || null,
        route: bewerkRoute.map((s, i) => ({ ...s, volgorde: i + 1, operatie_id: parseInt(s.operatie_id) })),
      });
      setBewerk(null);
      laad();
    } catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const maakNieuw = async () => {
    setBezig(true); setFout('');
    try {
      await api.post('/artikelen', {
        ...nieuwForm,
        diameter_mm: nieuwForm.diameter_mm || null,
        tanden_per_stuk: nieuwForm.tanden_per_stuk ? parseInt(nieuwForm.tanden_per_stuk) : null,
        productfiche_id: nieuwForm.productfiche_id || null,
        standaard_leverancier_id: nieuwForm.standaard_leverancier_id || null,
        route: nieuwRoute.map((s, i) => ({ ...s, volgorde: i + 1, operatie_id: parseInt(s.operatie_id) })),
      });
      setNieuw(null);
      setNieuwForm(leegForm());
      setNieuwRoute([]);
      laad();
    } catch (e) { setFout(e.response?.data?.error || e.message); }
    setBezig(false);
  };

  const toggleActief = async (a) => {
    if (a.actief) {
      await api.delete(`/artikelen/${a.id}`);
    } else {
      await api.put(`/artikelen/${a.id}`, { ...a, actief: true, route: [] });
    }
    laad();
  };

  const gefilterd = useMemo(() => artikelen.filter(a => {
    if (!toonInactief && !a.actief) return false;
    if (familieFilter && String(a.familie_id ?? a.productfiche_id) !== familieFilter) return false;
    if (zoek) {
      const q = zoek.toLowerCase();
      return `${a.artikelnummer || ''} ${a.naam} ${a.familie_naam || ''} ${a.fiche_naam || ''} ${a.standaard_materiaal || ''}`.toLowerCase().includes(q);
    }
    return true;
  }), [artikelen, zoek, familieFilter, toonInactief]);

  const inactiefAantal = artikelen.filter(a => !a.actief).length;

  const FormVeld = ({ label, children }) => (
    <div><label style={S.label}>{label}</label>{children}</div>
  );

  const renderForm = (form, setForm, route, setRoute, titel, onSla, onAnnuleer) => (
    <div style={{ background: '#fff', border: '1.5px solid #185FA5', borderRadius: 10, padding: 22, marginBottom: 20 }}>
      <div style={{ fontWeight: 600, fontSize: 15, color: '#1F3864', marginBottom: 18 }}>{titel}</div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
        <FormVeld label="Artikelnummer">
          <input style={S.input} value={form.artikelnummer} placeholder="bijv. CS-400-60T"
            onChange={e => setForm(f => ({ ...f, artikelnummer: e.target.value }))} />
        </FormVeld>
        <FormVeld label="Naam *">
          <input style={S.input} value={form.naam} placeholder="Omschrijving van het artikel"
            onChange={e => setForm(f => ({ ...f, naam: e.target.value }))} />
        </FormVeld>
        <FormVeld label="Productfiche (type)">
          <select style={S.input} value={form.productfiche_id || ''}
            onChange={e => {
              setForm(f => ({ ...f, productfiche_id: e.target.value }));
              if (route.length === 0) laadFicheRoute(e.target.value, setRoute);
            }}>
            <option value="">— geen —</option>
            {fiches.map(f => <option key={f.id} value={f.id}>{f.artikelnummer ? `${f.artikelnummer} — ` : ''}{f.omschrijving}</option>)}
          </select>
        </FormVeld>
        <FormVeld label="Standaard leverancier">
          <select style={S.input} value={form.standaard_leverancier_id || ''}
            onChange={e => setForm(f => ({ ...f, standaard_leverancier_id: e.target.value }))}>
            <option value="">— geen —</option>
            {leveranciers.map(l => <option key={l.id} value={l.id}>{l.naam}</option>)}
          </select>
        </FormVeld>
        <FormVeld label="Diameter (mm)">
          <input style={S.input} type="number" min="0" step="0.1" placeholder="bijv. 400"
            value={form.diameter_mm || ''}
            onChange={e => setForm(f => ({ ...f, diameter_mm: e.target.value }))} />
        </FormVeld>
        <FormVeld label="Tanden per stuk">
          <input style={S.input} type="number" min="0" step="1" placeholder="bijv. 60"
            value={form.tanden_per_stuk || ''}
            onChange={e => setForm(f => ({ ...f, tanden_per_stuk: e.target.value }))} />
        </FormVeld>
        <FormVeld label="Standaard materiaal">
          <input style={S.input} value={form.standaard_materiaal || ''} placeholder="bijv. HS staal, HM tanden..."
            onChange={e => setForm(f => ({ ...f, standaard_materiaal: e.target.value }))} />
        </FormVeld>
        <FormVeld label="Opmerkingen">
          <input style={S.input} value={form.opmerkingen || ''} placeholder="Bijzonderheden..."
            onChange={e => setForm(f => ({ ...f, opmerkingen: e.target.value }))} />
        </FormVeld>
      </div>

      {form.productfiche_id && route.length === 0 && (
        <button type="button" onClick={() => laadFicheRoute(form.productfiche_id, setRoute)}
          style={{ ...S.btnGhost, fontSize: 12, marginBottom: 12, color: '#185FA5', borderColor: '#185FA5' }}>
          ↓ Route laden van productfiche
        </button>
      )}

      <div style={{ borderTop: '1px solid #EEE', paddingTop: 14, marginBottom: 16 }}>
        <RouteEditor route={route} setRoute={setRoute} operaties={operaties} />
      </div>

      {fout && <div style={{ padding: '8px 12px', background: '#FDEDEC', border: '1px solid #E05040', borderRadius: 6, fontSize: 13, color: '#B03020', marginBottom: 10 }}>{fout}</div>}

      <div style={{ display: 'flex', gap: 8 }}>
        <button style={S.btnGreen} onClick={onSla} disabled={bezig || !form.naam}>
          {bezig ? 'Bezig...' : 'Opslaan'}
        </button>
        <button style={S.btnGhost} onClick={onAnnuleer}>Annuleren</button>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 24, maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: '#1F3864' }}>Artikelen</h1>
        {isPlanner && !nieuw && !bewerk && (
          <button style={S.btnBlue} onClick={() => { setNieuw(true); setNieuwForm(leegForm()); setNieuwRoute([]); setFout(''); }}>
            + Nieuw artikel
          </button>
        )}
      </div>

      {/* Nieuw formulier */}
      {nieuw && renderForm(
        nieuwForm, setNieuwForm, nieuwRoute, setNieuwRoute,
        'Nieuw artikel',
        maakNieuw,
        () => { setNieuw(null); setFout(''); }
      )}

      {/* Bewerk formulier */}
      {bewerk && renderForm(
        bewerk, (fn) => setBewerk(b => typeof fn === 'function' ? fn(b) : fn),
        bewerkRoute, setBewerkRoute,
        `Bewerken: ${bewerk.naam}`,
        slaOp,
        () => { setBewerk(null); setFout(''); }
      )}

      {/* Filter & zoek */}
      {!nieuw && !bewerk && (
        <>
          <div style={{ display: 'flex', gap: 10, marginBottom: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <input value={zoek} onChange={e => setZoek(e.target.value)}
              placeholder="Zoeken op artikelnummer, naam, materiaal, productfiche..."
              style={{ flex: 1, minWidth: 200, padding: '7px 12px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13 }} />
            {inactiefAantal > 0 && (
              <button onClick={() => setToonInactief(t => !t)}
                style={{ ...S.btnGhost, color: '#888' }}>
                {toonInactief ? `Verberg inactief (${inactiefAantal})` : `Toon inactief (${inactiefAantal})`}
              </button>
            )}
          </div>

          {/* Familie chips */}
          {families.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
              <button onClick={() => setFamilieFilter('')}
                style={{ padding: '4px 10px', borderRadius: 99, fontSize: 11, cursor: 'pointer', border: '1px solid #DDD', background: !familieFilter ? '#1F3864' : '#fff', color: !familieFilter ? '#fff' : '#555' }}>
                Alle
              </button>
              {families.map(f => (
                <button key={f.id} onClick={() => setFamilieFilter(familieFilter === String(f.id) ? '' : String(f.id))}
                  style={{ padding: '4px 10px', borderRadius: 99, fontSize: 11, cursor: 'pointer', border: `1px solid ${familieFilter === String(f.id) ? (f.kleur || '#185FA5') : '#DDD'}`, background: familieFilter === String(f.id) ? (f.kleur || '#185FA5') + '20' : '#fff', color: familieFilter === String(f.id) ? (f.kleur || '#185FA5') : '#555', fontWeight: familieFilter === String(f.id) ? 600 : 400 }}>
                  {f.naam}
                </button>
              ))}
            </div>
          )}

          {/* Lijst */}
          <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 8, overflow: 'hidden' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr 160px 90px 90px 130px', background: '#1F3864', color: '#fff', padding: '8px 14px', fontSize: 11, fontWeight: 500, gap: 0 }}>
              {['Artikelnr.', 'Naam', 'Productfiche', 'Diameter', 'Tanden', ''].map(h => <div key={h}>{h}</div>)}
            </div>

            {gefilterd.length === 0 && (
              <div style={{ padding: '24px 14px', color: '#AAA', fontStyle: 'italic', fontSize: 13, textAlign: 'center' }}>
                {artikelen.length === 0 ? 'Nog geen artikelen aangemaakt.' : 'Geen artikelen gevonden.'}
              </div>
            )}

            {gefilterd.map((a, i) => (
              <div key={a.id} style={{
                display: 'grid', gridTemplateColumns: '120px 1fr 160px 90px 90px 130px',
                padding: '10px 14px', alignItems: 'center', gap: 0,
                background: i % 2 === 0 ? '#fff' : '#FAFAFA',
                borderBottom: '1px solid #F0F0F0',
                opacity: a.actief ? 1 : 0.55,
              }}>
                <div style={{ fontSize: 12, color: '#185FA5', fontWeight: 600 }}>
                  {a.artikelnummer || <span style={{ color: '#CCC' }}>—</span>}
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500, color: '#1F3864' }}>{a.naam}</div>
                  <div style={{ fontSize: 11, color: '#888', display: 'flex', gap: 8, marginTop: 2 }}>
                    {a.familie_naam && (
                      <span style={{ padding: '1px 7px', borderRadius: 99, background: (a.familie_kleur || '#888') + '20', color: a.familie_kleur || '#888', fontSize: 10, fontWeight: 500 }}>
                        {a.familie_naam}
                      </span>
                    )}
                    {parseInt(a.stap_count) > 0 && <span>{a.stap_count} stappen</span>}
                    {parseInt(a.order_count) > 0 && <span>{a.order_count} orders</span>}
                  </div>
                </div>
                <div style={{ fontSize: 12, color: '#555' }}>
                  {a.fiche_naam || <span style={{ color: '#CCC' }}>—</span>}
                </div>
                <div style={{ fontSize: 12, color: '#444' }}>
                  {a.diameter_mm ? `${parseFloat(a.diameter_mm)} mm` : <span style={{ color: '#CCC' }}>—</span>}
                </div>
                <div style={{ fontSize: 12, color: '#444' }}>
                  {a.tanden_per_stuk ? `${a.tanden_per_stuk} t/stuk` : <span style={{ color: '#CCC' }}>—</span>}
                </div>
                <div style={{ display: 'flex', gap: 5 }}>
                  {isPlanner && (
                    <>
                      <button style={S.btnGhost} onClick={() => openBewerk(a)}>Bewerk</button>
                      <button style={{ ...S.btnGhost, color: a.actief ? '#C0392B' : '#1A7A3C', borderColor: a.actief ? '#E05040' : '#82C96B' }}
                        onClick={() => toggleActief(a)}>
                        {a.actief ? 'Deact.' : 'Activeer'}
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#AAA' }}>{gefilterd.length} van {artikelen.length} artikelen</div>
        </>
      )}
    </div>
  );
}
